import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown } from 'semantic-ui-react';
import { ExportFormat } from 'subdomains/cpo/types/exports';

type ExportDropdownProps = {
  handleExport: (format: ExportFormat) => void;
};

export function ExportsDropdown({ handleExport }: ExportDropdownProps) {
  const { t } = useTranslation();
  return (
    <Dropdown
      button
      basic
      text={t('common.exports', 'Exports')}
      direction="left">
      <Dropdown.Menu>
        <Dropdown.Item
          icon="download"
          text={t('common.exportCSV', 'Export CSV')}
          onClick={() => handleExport('csv')}
        />
        <Dropdown.Item
          icon="download"
          text={t('common.exportXLSX', 'Export XLSX')}
          onClick={() => handleExport('xlsx')}
        />
      </Dropdown.Menu>
    </Dropdown>
  );
}
